import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            // Recent / saved dispatches loaded from the database
            savedDispatches: [],
            // The dispatch currently being built through the wizard
            currentDispatch: {
                dispatchId: null,
                name: '',
                parameters: {
                    dispatchDate: null,
                    // How this run is delivered: 'tanker' (bulk, single-shell) or
                    // 'totes' (IBCs on a deck truck). Chosen here because it decides
                    // what the Supply and Delivery steps need to ask for.
                    deliveryMethod: 'tanker',
                    // Multi-select. An empty list means "every product".
                    product: [],
                    operator: [],
                    area: [],
                    maxDte: null,
                    minUllage: null,
                    maxFillPct: 95,
                },
                selectedSites: [],
                // Supply (tote sizes / counts) captured on the Supply step.
                supply: {},
                // Truck fleet / clustering settings from the dispatch map.
                deliveryParams: {},
            },
        };
    },
    mutations,
    actions,
    getters
};
